<template>
  <div class="flex w-full items-center gap-4">
    <JadeInputField
      label=""
      size="medium"
      :value.sync="id"
      :placeholder="$t('placeholder')"
      :leadingItem="{ type: 'icon', content: 'action-search' }"
    >
    </JadeInputField>
    <JadeButton
      variant="primary-solid"
      size="medium"
      :disabled="loading"
      @click="searchClick"
      class="w-28"
    >
      {{ $t('search') }}
    </JadeButton>
    <div>
      <jade-dropdown
        v-if="canRequestTerminal"
        :allowedPlacements="['bottom-end']"
        @toggleOpen="open = !open"
        :open="open"
      >
        <template #trigger>
          <JadeActionButton dropdownIndicator>
            {{ $t('actions') }}
          </JadeActionButton>
        </template>
        <jade-list-item
          :label="$t('request-card-machine')"
          @onClick="$router.push({ name: terminalRequestRouteName })"
          @keyup.page-down="$router.push({ name: terminalRequestRouteName })"
          as="button"
        />
        <jade-list-item
          v-if="showRequestPapperRoll"
          :label="$t('request-paper-roll')"
          @onClick="$router.push({ name: terminalRollRequestRouteName })"
          @keyup.page-down="
            $router.push({ name: terminalRollRequestRouteName })
          "
          as="button"
        />
      </jade-dropdown>
    </div>
  </div>
</template>

<script>
import {
  JadeButton,
  JadeDropdown,
  JadeInputField,
  JadeActionButton,
  JadeListItem
} from '@jade'
import { mapGetters } from 'vuex'

import { physicalWorldCreateOrderEnabled } from '@/actions-permission/physical-world.permissions'

import { TERMINAL_ROUTES_ENUM } from '@/enums/physical-world.enum'

export default {
  name: 'TerminalsSearch',
  components: {
    JadeInputField,
    JadeButton,
    JadeActionButton,
    JadeDropdown,
    JadeListItem
  },
  props: {
    loading: Boolean
  },
  data () {
    return {
      open: false,
      id: '',
      terminalRollRequestRouteName: TERMINAL_ROUTES_ENUM.TERMINAL_ROLL_REQUEST,
      terminalRequestRouteName: TERMINAL_ROUTES_ENUM.TERMINAL_REQUEST
    }
  },
  computed: {
    ...mapGetters(['permissionIsEnabled']),
    showRequestPapperRoll () {
      return this.items?.length > 0
    },
    canRequestTerminal () {
      return physicalWorldCreateOrderEnabled(this.permissionIsEnabled)
    }
  },
  methods: {
    searchClick () {
      this.$emit('searchClick', this.id)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "search": "Buscar",
      "placeholder": "Buscar por número do série",
      "status": "Status",
      "terminals": "Lista de maquininhas",
      "actions": "Ações",
      "request_terminal": "Solicitar Maquininha",
      "request-card-machine": "Solicitação de maquininha",
      "request-paper-roll": "Solicitação de bobina"
    },
    "en-US": {
      "search": "Search",
      "placeholder": "Search by serial number",
      "status": "Status",
      "terminals": "Terminals List",
      "actions": "Actions",
      "request_terminal": "Request Terminal",
      "request-card-machine": "Machine card request",
      "request-paper-roll": "Paper roll request"
    }
  }
</i18n>
